module.exports = __webpack_public_path__ + "assets/server.f13cf274.svg";